import React, { useEffect, useState, useRef } from "react";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";
import { InputNumber } from "primereact/inputnumber";

import { Calendars } from "../../../components/Calendar/Calendar";
import { RadioButton } from "primereact/radiobutton";
import { Loading } from "../../../components/Loading/Loading";
import { validateInputText, validateRdo } from "../../../utilities/ValidateUtil";
import { dataUserSession } from "../../../utilities/dataSession";
import { useHistory } from "react-router-dom";
import { formatDateAPI } from "../../../utilities/DateUtil";
import ValidateService from "../../../components/ValidateService/ValidateService";
import DialogGenReport from "../../../components/DialogReport/DialogGenReport";
import { DialogOpenReport } from "../../../components/DialogService/DialogService";
import { DialogConfirm } from "../../../components/DialogService/DialogService";
import { FooterButtonSigle } from "../../../components/FooterButton/FooterButton";

// PAGEe

import P242List from "./P242List";

// SERVICE
import { pAssessmentInfo, pAssessmentUpdate } from "../../../service/200/P242Service";
import { onGetAssessmentPrintResult, onGetAssessmentPrintScore } from "../../../Report/245/RPT245CallService";
//Report
import { pdfRPT245 } from "../../../Report/245/RPT245PDF";
import { RPT245Word } from "../../../Report/245/RPT245WORD";

export default function P242() {
    const history = useHistory();

    const toast = useRef(null);
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    // DIALOG PDF
    const [dialogPDF, setDialogPDF] = useState(false);
    const [dialogReport, setDialogReport] = useState({ dialog: false, show: false });
    const [dataRPT, setDataRPT] = useState([]);
    const [dataRPTScore, setDataRPTScore] = useState([]);

    //Dialog
    const [confirmDialog, setConfirmDialog] = useState(false);
    const [dialogOption, setdialogOption] = useState({
        header: "",
        content: "",
        onConfirm: () => {},
        onCancle: () => {},
        footerBtn: () => {},
    });

    // SEARCH
    const [searchData, setSearchData] = useState({
        assessmentNo: 0,
        contractNo: "",
        userId: dataUserSession() ? dataUserSession().userId : "",
    });

    // DATA
    const [count, setCount] = useState(0);
    const [dataTable, setDataTable] = useState([]);
    const [formData, setFormData] = useState({
        assessmentBeginDate: new Date(),
        assessmentEndDate: new Date(),
    });
    const [errData, setErrData] = useState(null);

    useEffect(() => {
        if (dataUserSession()) {
            if (history.location.state && history.location.state.dataSrh) {
                setSearchData({
                    ...searchData,
                    ...history.location.state.dataSrh,
                    userId: dataUserSession().userId,
                });
            } else {
                // For Test
                // setSearchData({
                //     assessmentNo: 1,
                //     contractNo: "ป.16-1/64",
                //     userId: "s16",
                //     updateUserId: "s16",
                // });

                // For Production
                handlerBackPage();
            }
        } else {
            history.push("/login");
        }
    }, []);

    useEffect(() => {
        if (searchData.contractNo !== "") {
            onGetAssessmentInfo();
        }
    }, [searchData]);

    const onGetAssessmentInfo = () => {
        setLoading(true);
        const req = {
            assessmentNo: searchData.assessmentNo,
            contractNo: searchData.contractNo,
            userId: searchData.userId,
        };
        pAssessmentInfo(req).then(
            (res) => {
                setLoading(false);
                if (res != undefined) {
                    let temp = [];
                    let index = 0;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                            assessmentBeginDate: element.assessmentBeginDate === null ? new Date() : element.assessmentBeginDate,
                            assessmentEndDate: element.assessmentEndDate === null ? new Date() : element.assessmentEndDate,
                        });
                        index++;
                    });
                    setDataTable(temp);
                    setFormData(temp[0]);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const validation = (object) => {
        if (object.assessmentBeginDate === null || object.assessmentEndDate === "" || object.assessmentType === "" || object.constructionResult === "" || object.assessmentResult === "") {
            setSubmitted(true);
            return false;
        } else {
            setSubmitted(false);
            return true;
        }
    };

    const footerButtonSingle = (_assessmentNo) => {
        const load = () => {
            setConfirmDialog(false);
            // onGetAssessmentInfo();

            setSearchData((curr) => ({ ...curr, assessmentNo: _assessmentNo }));
        };
        return <FooterButtonSigle btnLabel="ปิด" onClick={() => load()} />;
    };

    const submitForm = () => {
        if (validation(formData)) {
            setLoading(true);

            for (let index = 0; index < dataTable.length; index++) {
                const req = {
                    assessmentBeginDate: setValViewForm("assessmentBeginDate") === "" ? "" : formatDateAPI(setValViewForm("assessmentBeginDate")),
                    assessmentDetail: setValViewForm("assessmentDetail"),
                    assessmentEndDate: setValViewForm("assessmentEndDate") === "" ? "" : formatDateAPI(setValViewForm("assessmentEndDate")),
                    assessmentNo: setValViewForm("assessmentNo"),
                    assessmentResult: setValViewForm("assessmentResult"),
                    assessmentType: setValViewForm("assessmentType"),
                    constructionResult: setValViewForm("constructionResult"),
                    contractNo: setValViewForm("contractNo"),
                    criteriaNo: dataTable[index].criteriaNo,
                    criteriaRemark: dataTable[index].criteriaRemark,
                    criteriaScore: setValViewForm("criteriaScore"),
                    deductScore: setValViewForm("deductScore"),
                    fineAmount: setValViewForm("fineAmount") === null ? 0 : setValViewForm("fineAmount"),
                    userId: searchData.userId,
                };
                pAssessmentUpdate(req).then(
                    (res) => {
                        setLoading(false);
                        const _r = res[0];

                        if (index === dataTable.length - 1) {
                            setdialogOption({
                                ...dialogOption,

                                header: "",
                                content: _r.statusText,
                                footerBtn: () => footerButtonSingle(setValViewForm("assessmentNo")),
                            });
                            setConfirmDialog({ open: true });
                        }
                    },
                    function (err) {
                        setLoading(false);
                        setErrData(err);
                    }
                );
            }
        }
    };

    const handlerBackPage = () => {
        history.push({ pathname: "/241", state: { dataSrh: { contractNo: searchData.contractNo } } });
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };
    const handlerInpusText = (e, rowData, inputname) => {
        const objIndex = dataTable.findIndex((obj) => obj.index == rowData.index);
        dataTable[objIndex][inputname] = e;
        setCount(count + 1);
        setDataTable(dataTable);
    };

    const setValViewForm = (_key) => {
        if (formData != undefined) return formData[_key];
    };

    const setvalForm = (key, val) => {
        setFormData({ ...formData, [key]: val });
    };

    const handlerDetail = () => {
        history.push({ pathname: "/243", state: { dataSrh: { contractNo: searchData.contractNo, assessmentNo: searchData.assessmentNo } } });
    };

    const handlerReport = () => {
        let req = {
            assessmentNo: searchData.assessmentNo,
            contractNo: searchData.contractNo,
            userId: dataUserSession() ? dataUserSession().userId : "",
        };
        
        onGetAssessmentPrintResult(setLoading, req, setDataRPT, toast);
        onGetAssessmentPrintScore(setLoading, req, setDataRPTScore, toast);
        setDialogReport({ dialog: true, show: false });
    };

    const onExport = (act) => {
        switch (act) {
            case "PDF":
                pdfRPT245(dataRPT, dataRPTScore, setLoading, setDialogPDF);
                break;

            case "WORD":
                RPT245Word(dataRPT, dataRPTScore, setLoading, setDialogPDF);
                break;

            default:
                break;
        }
        setDialogReport({ dialog: false, show: false });
    };

    const disReport_Detail = () => {
        if (searchData !== null) {
            if (searchData.assessmentNo === 0) {
                return true;
            } else {
                return false;
            }
        }
    };

    return (
        <>
            <Loading loading={loading} />
            <ValidateService err={errData} setErr={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">
                    <div className="card">
                        {/* <h2 className="p-m-0">รายละเอียดและผลการประเมิน</h2>
                        <hr /> */}
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="contractNo">เลขที่สัญญา</label>
                                <InputText id="contractNo" type="text" value={setValViewForm("contractNo")} onChange={(e) => setvalForm("contractNo", e.target.value)} maxLength="20" disabled={true} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="contractorName">ผู้รับจ้าง</label>
                                <InputText id="contractorName" type="text" value={setValViewForm("contractorName")} onChange={(e) => setvalForm("contractorName", e.target.value)} maxLength="200" disabled={true} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="assessmentNo">ประเมินครั้งที่</label>
                                <InputText id="assessmentNo" type="text" value={setValViewForm("assessmentNo")} onChange={(e) => setvalForm("assessmentNo", e.target.value)} maxLength="10" disabled={true} />
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-3">
                                <label htmlFor="assessmentType">การประเมิน</label>
                                <span style={{ color: "red" }}>*</span>
                                <div className="p-field-radiobutton">
                                    <RadioButton inputId="assessmentType" name="assessmentType" value="1" onChange={(e) => setvalForm("assessmentType", e.value)} checked={setValViewForm("assessmentType") === "1"} />
                                    <label htmlFor="assessmentType">ระหว่างก่อสร้าง</label>
                                </div>
                                <div className="p-field-radiobutton">
                                    <RadioButton inputId="assessmentType" name="assessmentType" value="2" onChange={(e) => setvalForm("assessmentType", e.value)} checked={setValViewForm("assessmentType") === "2"} />
                                    <label htmlFor="assessmentType">เริ่มงาน-งานเสร็จ</label>
                                </div>
                                {submitted && !setValViewForm("assessmentType") && validateRdo("assessmentType", "การประเมิน")}
                            </div>
                        </div>

                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="assessmentBeginDate">เริ่มประเมินจากวันที่</label>
                                <span style={{ color: "red" }}>*</span>
                                <Calendars className="p-invalid" value={new Date(setValViewForm("assessmentBeginDate"))} onChange={(e) => setvalForm("assessmentBeginDate", e.target.value)} maxLength="10" />
                                {submitted && !setValViewForm("assessmentBeginDate") && validateInputText("assessmentBeginDate", "เริ่มประเมินจากวันที่")}
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="assessmentEndate">ถึงวันที่</label>
                                <span style={{ color: "red" }}>*</span>
                                <Calendars value={new Date(setValViewForm("assessmentEndDate"))} onChange={(e) => setvalForm("assessmentEndDate", e.target.value)} maxLength="10" />
                                {submitted && !setValViewForm("assessmentEndDate") && validateInputText("assessmentEndDate", "ถึงวันที่")}
                            </div>
                        </div>
                        <hr />
                        <P242List dataTable={dataTable} setheadlerInpusText={handlerInpusText} setActionDetail={handlerDetail} setDis={disReport_Detail} />
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-5"></div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="request_no">ถูกตัดคะแนนสะสม</label>
                                <div className="p-grid">
                                    <div className="p-col-6">
                                        <InputNumber
                                            id="deductScore"
                                            type="text"
                                            placeholder="ระบุ ถูกตัดคะแนนสะสม"
                                            value={setValViewForm("deductScore")}
                                            useGrouping={false}
                                            minFractionDigits={2}
                                            maxFractionDigits={2}
                                            mode="decimal"
                                            min={0}
                                            max={9999999999}
                                            onValueChange={(e) => setvalForm("deductScore", e.value)}
                                        />
                                    </div>
                                    <div className=" p-field p-col">
                                        <span>คะแนน</span>
                                    </div>
                                </div>
                            </div>
                            <div className="p-field p-col-12 p-md-3"></div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-3">
                                <label htmlFor="constructionResult">ผลงานที่ทำได้</label>
                                <span style={{ color: "red" }}>*</span>
                                <div className="p-field-radiobutton">
                                    <RadioButton inputId="constructionResult" name="constructionResult" value="1" onChange={(e) => setvalForm("constructionResult", e.value)} checked={setValViewForm("constructionResult") === "1"} />
                                    <label htmlFor="constructionResult">เร็วกว่าแผน/สัญญา</label>
                                </div>
                                <div className="p-field-radiobutton">
                                    <RadioButton inputId="constructionResult" name="constructionResult" value="2" onChange={(e) => setvalForm("constructionResult", e.value)} checked={setValViewForm("constructionResult") === "2"} />
                                    <label htmlFor="constructionResult">ทันตามแผน/สัญญา</label>
                                </div>
                                <div className="p-field-radiobutton">
                                    <RadioButton inputId="constructionResult" name="constructionResult" value="3" onChange={(e) => setvalForm("constructionResult", e.value)} checked={setValViewForm("constructionResult") === "3"} />
                                    <label htmlFor="constructionResult">ช้ากว่าแผน/สัญญา</label>
                                </div>
                                {submitted && !setValViewForm("constructionResult") && validateRdo("constructionResult", "ผลงานที่ทำได้")}
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-3">
                                <label htmlFor="assessmentResult">ผลการประเมิน</label>
                                <span style={{ color: "red" }}>*</span>
                                <div className="p-field-radiobutton">
                                    <RadioButton inputId="assessmentResult" name="assessmentResult" value="1" onChange={(e) => setvalForm("assessmentResult", e.value)} checked={setValViewForm("assessmentResult") === "1"} />
                                    <label htmlFor="assessmentResult">ผ่านการประเมิน</label>
                                </div>
                                <div className="p-field-radiobutton">
                                    <RadioButton inputId="assessmentResult" name="assessmentResult" value="2" onChange={(e) => setvalForm("assessmentResult", e.value)} checked={setValViewForm("assessmentResult") === "2"} />
                                    <label htmlFor="assessmentResult">ไม่ผ่านการประเมิน</label>
                                </div>
                                {submitted && !setValViewForm("assessmentResult") && validateRdo("assessmentResult", "ผลการประเมิน")}
                                <div className="p-fluid p-formgrid p-grid">
                                    <div className="p-field p-col-12 p-md-12">
                                        <label htmlFor="fineAmount">ค่าปรับ</label>
                                        <div className="p-grid">
                                            <div className="p-col-6">
                                                <InputNumber
                                                    id="fineAmount"
                                                    type="text"
                                                    placeholder="ระบุ ค่าปรับ"
                                                    value={setValViewForm("fineAmount")}
                                                    mode="decimal"
                                                    min={0}
                                                    max={999999999999999}
                                                    minFractionDigits={2}
                                                    maxFractionDigits={2}
                                                    useGrouping={false}
                                                    onValueChange={(e) => setvalForm("fineAmount", e.value)}
                                                />
                                            </div>
                                            <div className=" p-field p-col">
                                                <span>บาท</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-6">
                                <label htmlFor="assessmentDetail">เลขที่สัญญา</label>
                                <InputTextarea rows={5} id="assessmentDetail" value={setValViewForm("assessmentDetail")} placeholder="ระบุ เลขที่สัญญา" maxLength={400} onChange={(e) => setvalForm("assessmentDetail", e.target.value)} />
                            </div>
                        </div>
                        <div className="p-grid" style={{ textAlign: "center" }}>
                            <div className="p-col-12">
                                <Button className="p-button-success p-button" icon="pi pi-save" label="บันทึก" style={{ width: 170 }} onClick={() => submitForm()} />
                                <Button className="p-button-secondary p-button" icon="pi pi-arrow-left" label="กลับหน้าจอหลัก" style={{ width: 170, marginLeft: "5px" }} onClick={() => handlerBackPage()} />
                                <Button className="p-button-indo p-button" icon="pi pi-print" label="พิมพ์" style={{ width: 170, marginLeft: "5px" }} onClick={() => handlerReport()} disabled={disReport_Detail()} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <DialogGenReport dialog={dialogReport} setDialog={setDialogReport} setExport={onExport} pdf={true} word={true} />
            <DialogOpenReport header="พิมพ์รายงานการประเมิน" dialog={dialogPDF} setDialog={setDialogPDF} />
            <DialogConfirm visible={confirmDialog.open} header={dialogOption.header} modal footer={dialogOption.footerBtn} onHide={() => setConfirmDialog(false)} textContent={dialogOption.content} />
        </>
    );
}
